import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { TermsAndConditions } from "@akina/domain";
import { QueryKeys } from "../QueryKeys";
import { useApi } from "../useApi";

export const useUpdateTermsAndConditionsStatus = (params?: { onSuccess?: () => void; onError?: () => void }) => {
  const { api } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (status: TermsAndConditions) => api.patient.updateTermsAcceptedStatus(status),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.fetchTermsAndConditionsStatus],
      });
      if (params?.onSuccess) {
        params.onSuccess();
      }
    },
  });
};
